import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DateFormat, Language } from '../models/enums/language.enum';

@Injectable()
export abstract class ILocalizationService {
  public abstract loadUserLanguage(): Observable<Language>;
  public abstract loadUserDateFormat(): Observable<DateFormat>;
  public abstract saveUserLanguage(language: Language): Observable<void>;
  public abstract saveUserDateFormat(dateFormat: DateFormat): Observable<void>;

  public getSupportedLanguages(): Language[] | null {
    return null;
  }

  public getBrowserLanguage(availableLanguages: Language[], fallback: Language): Language {
    const browserLocale = navigator.language;
    const language = availableLanguages?.find((availableLanguage) => browserLocale.startsWith(availableLanguage));
    return language ? language : fallback;
  }

  public getBrowserDateformat(availableLanguages: DateFormat[], fallback: DateFormat): DateFormat {
    const browserLocale = navigator.language;
    const dateFormat = availableLanguages?.find((availableLanguage) => browserLocale.startsWith(availableLanguage));
    return dateFormat ? dateFormat : fallback;
  }
}
